import { useState } from "react";
import { useApi, fmtDT } from "@/lib/api";
import { PageHeader, Table, Th, Td, Pill } from "@/components/kit";

const ENTITIES = ["", "check_runs", "temp_logs", "incidents", "deliveries", "equipment", "check_templates", "dishes", "haccp_plans", "training", "suppliers", "team", "venues", "audit_pack", "billing"];

export default function AuditLog() {
  const [entity, setEntity] = useState("");
  const { data } = useApi("/audit-log", { entity: entity || undefined });
  return (
    <div>
      <PageHeader eyebrow="Append-only" title="Audit trail" subtitle="Who did what, when. Records can't be silently edited — corrections are logged alongside the original."
        actions={<select data-testid="audit-entity-filter" className="ka-input w-56" value={entity} onChange={(e) => setEntity(e.target.value)}>{ENTITIES.map((e) => <option key={e} value={e}>{e ? e.replace(/_/g, " ") : "All records"}</option>)}</select>} />
      <Table testid="audit-log-table">
        <thead><tr><Th>When</Th><Th>Who</Th><Th>Action</Th><Th>Record</Th><Th>Detail</Th></tr></thead>
        <tbody>
          {(data || []).map((a) => (
            <tr key={a.id}>
              <Td className="whitespace-nowrap font-mono text-xs">{fmtDT(a.at)}</Td>
              <Td><div className="font-medium text-slate-900">{a.user_name}</div><div className="text-xs capitalize text-slate-500">{a.role}</div></Td>
              <Td><Pill status="low" label={a.action} /></Td>
              <Td className="text-xs">{a.entity.replace(/_/g, " ")}</Td>
              <Td className="text-sm">{a.summary}</Td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}
